__turbopack_context__.v({
  "videoItem": "cuW5WG_videoItem",
});
